import { marker } from "@jsverse/transloco-keys-manager/marker";
import { blobToDataUrl } from "src/app/support/blob";
import { filesize } from "src/app/support/filesize";
import { sntTranslate } from "src/app/support/translate";
import { EditorOptions as TinyEditorOptions, TinyMCE, Editor } from "tinymce";
declare const tinyMCE: TinyMCE;

const DEFAULT: Partial<TinyEditorOptions> = {
  menubar: false,
  plugins:
    "preview casechange importcss tinydrive searchreplace autolink save directionality advcode visualblocks visualchars fullscreen image link media mediaembed template codesample table charmap pagebreak nonbreaking anchor tableofcontents insertdatetime advlist lists checklist wordcount editimage help formatpainter permanentpen pageembed charmap quickbars emoticons advtable export".split(
      " "
    ),
  toolbar:
    "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist checklist | forecolor backcolor casechange permanentpen formatpainter removeformat | pagebreak | charmap emoticons | fullscreen  preview | pageembed template link anchor | spellchecker",
  toolbar_mode: "wrap",
  spellchecker_language: "it",
  height: "100%",
  language: "it",
  content_langs: [{ title: "Italiano", code: "it" }],
  resize: false,
  font_size_formats: "6pt 7pt 8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt"
};

export function initWysiwygEditor(
  container: HTMLElement,
  callbackContentChanged: (content: string) => void,
  options?: Partial<TinyEditorOptions>,
  initialContent?: string,
  customOptions?: {
    imageMaxSize?: number;
  }
): Promise<Editor> {
  return new Promise((res) => {
    tinyMCE.init({
      target: container,
      ...DEFAULT,
      ...(options || {}),
      images_upload_handler: (blobInfo, progress) =>
        new Promise<string>(async (resolve, reject) => {
          if (
            customOptions?.imageMaxSize &&
            customOptions!.imageMaxSize < blobInfo.blob().size
          ) {
            return reject({
              message: `${sntTranslate(
                marker("dimimensione massima ")
              )} ${filesize(customOptions!.imageMaxSize, {
                round: 0,
                base: 2
              })}`,
              remove: true
            });
          }

          return resolve(await blobToDataUrl(blobInfo.blob()));
        }),
      setup: (editor: Editor) => {
        editor.ui.registry.addIcon(
          "signature-icon",
          `
          <svg width="24px" height="24px" viewBox="0 0 24 19" version="1.1">
            <g id="surface1">
              <path style=" stroke:none;fill-rule:nonzero;fill:rgb(0%,0%,0%);fill-opacity:1;" d="M 6 6.53125 C 6 6.859375 5.730469 7.125 5.398438 7.125 C 5.070312 7.125 4.800781 6.859375 4.800781 6.53125 L 4.800781 4.75 C 4.800781 2.78125 6.378906 1.1875 8.398438 1.1875 C 10.386719 1.1875 12 2.78125 12 4.75 L 12 4.875 C 12 5.730469 11.9375 6.582031 11.804688 7.425781 L 17.242188 5.960938 C 17.472656 5.898438 17.714844 5.941406 17.863281 6.15625 C 18.015625 6.335938 18.042969 6.585938 17.9375 6.796875 L 15.972656 10.6875 L 21 10.6875 C 21.328125 10.6875 21.601562 10.953125 21.601562 11.28125 C 21.601562 11.609375 21.328125 11.875 21 11.875 L 15 11.875 C 14.792969 11.875 14.597656 11.765625 14.488281 11.59375 C 14.382812 11.417969 14.371094 11.199219 14.464844 11.015625 L 16.265625 7.457031 L 11.558594 8.722656 C 11.5 8.964844 11.402344 9.210938 11.371094 9.453125 L 11.101562 10.40625 C 10.675781 11.925781 10.066406 13.394531 9.28125 14.734375 L 8.265625 16.554688 C 7.824219 17.328125 6.992188 17.8125 6.09375 17.8125 C 4.71875 17.8125 3.566406 16.707031 3.566406 15.34375 L 3.566406 11.910156 C 3.566406 10.570312 4.503906 9.394531 5.808594 9.042969 L 10.53125 7.769531 C 10.710938 6.816406 10.765625 5.847656 10.765625 4.875 L 10.765625 4.75 C 10.765625 3.4375 9.722656 2.375 8.367188 2.375 C 7.078125 2.375 5.964844 3.4375 5.964844 4.75 Z M 4.800781 11.910156 L 4.800781 15.34375 C 4.800781 16.054688 5.378906 16.625 6.09375 16.625 C 6.558594 16.625 6.988281 16.375 7.21875 15.972656 L 8.234375 14.1875 C 8.96875 12.894531 9.542969 11.519531 9.945312 10.089844 L 10.214844 9.132812 L 10.226562 9.082031 L 6.128906 10.191406 C 5.34375 10.402344 4.800781 11.101562 4.800781 11.910156 Z M 1.800781 14.25 C 2.132812 14.25 2.398438 14.515625 2.398438 14.84375 C 2.398438 15.171875 2.132812 15.4375 1.800781 15.4375 L 0.601562 15.4375 C 0.269531 15.4375 0 15.171875 0 14.84375 C 0 14.515625 0.269531 14.25 0.601562 14.25 Z M 23.398438 14.25 C 23.730469 14.25 24 14.515625 24 14.84375 C 24 15.171875 23.730469 15.4375 23.398438 15.4375 L 12.601562 15.4375 C 12.269531 15.4375 12 15.171875 12 14.84375 C 12 14.515625 12.269531 14.25 12.601562 14.25 Z M 23.398438 14.25 "/>
            </g>
          </svg>
        `
        );

        editor.ui.registry.addMenuButton("signature", {
          text: sntTranslate(marker("Firma")),
          icon: "signature-icon",
          fetch: (callback) => {
            callback([
              {
                type: "menuitem",
                text: sntTranslate(marker("Firma del cliente")),
                onAction: () => {
                  editor.insertContent(
                    ` 
                      <span contenteditable="false" style="background: white; position: relative; padding: 12px; border: 1px dashed #ccc;">
                        <span style="position: absolute; top: 0; left: 0; z-index: -1; user-select: none; color: #ffffff">
                          ##customerSignature##
                        </span>
                        <span style="width: max-content;">
                          ${sntTranslate(marker("Firma smart del cliente"))}
                        </span>
                      </span>
                    `
                  );
                }
              },
              {
                type: "menuitem",
                text: sntTranslate(marker("Firma dello staff")),
                onAction: () => {
                  editor.insertContent(
                    ` 
                    <!-- start staff signature -->
                      <span staffSignature="true" contenteditable="false" style="position: relative; padding: 12px; border: 1px dashed #ccc;">
                        <span style="position: absolute; top: 0; left: 0; z-index: -1; user-select: none; color: #ffffff">
                          ##staffSignature##
                        </span>
                        <span style="width: max-content;">
                          ${sntTranslate(marker("Firma smart dello staff"))}
                        </span>
                      </span>
                      <!-- end staff signature -->
                    `
                  );
                }
              }
            ]);
          }
        });

        editor.on("init", () => {
          if (initialContent) {
            editor.setContent(initialContent, {
              format: "html",
              initial: true,
              no_events: true
            });
          }

          res(editor);
        });

        editor.on("keyup", () => {
          callbackContentChanged(editor.getContent());
        });
        editor.on("paste", () => {
          callbackContentChanged(editor.getContent());
        });
        editor.on("cut", () => {
          callbackContentChanged(editor.getContent());
        });
        editor.on("change", () => {
          callbackContentChanged(editor.getContent());
        });

        if (options?.setup) {
          options.setup(editor);
        }
      }
    });
  });
}
